import type { CSSProperties, FC } from "react";
import type {
    JustifySettingsUnion,
    TextComponentSettings,
} from "../../../Routes/Settings/CustomerDisplay/CustomerDisplayTypes";
import type { CustomerDisplayComponentProps } from "../CustomerDisplay";

interface Props extends CustomerDisplayComponentProps<TextComponentSettings, null> {}

type AlignType = CSSProperties["textAlign"];

const textMap: Record<JustifySettingsUnion, AlignType> = {
    "flex-start": "left" as AlignType,
    "center"    : "center" as AlignType,
    "flex-end"  : "right" as AlignType,
};

export const CustomerDisplayText: FC<Props> = ({ settings }) => {
    const style: CSSProperties = {
        backgroundColor: settings.background,
        color          : settings.color,
        fontSize       : settings.fontSize + "pt",
        fontStyle      : settings.italic ? "italic" : "normal",
        fontWeight     : settings.bold ? "bold" : "normal",
        textDecoration : settings.underline ? "underline" : "none",
        textAlign      : textMap[settings.justify],
        justifyContent : settings.justify,
        alignItems     : settings.align,
    };

    return (
        <div
            className="customer-display-text w-full h-full"
            style={style}
        >
            {settings.text}
        </div>
    );
};
